
// EBE notes: for more advanced feature, especially if we want to use several languages, this might be useful to add compliant React Localization support 
// More information described here, in this article
// @see : https://medium.com/@ryandrewjohnson/adding-multi-language-support-to-your-react-redux-app-cf6e64250050

export const messagesDictionary = {
    'FIREBASE_ERROR_CODE': { 
        'auth/email-already-in-use':'Oups, ton pseudo est déjà pris :/ Trouves-en un autre !',
        'auth/all-slots-used':'Oups, visiblement vous aimez déjà beaucoup Kids-Matin :) Pour créer un nouveau compte, vous devez vous inscrire avec un autre mail. ',
        'auth/wrong-password':'ton ancien mot de passe n\'est pas le bon',
        'auth/requires-recent-login':'Pour modifier ton mot de passe, tu dois te déconnecter puis te reconnecter',
        'auth/user-token-expired':'Pour modifier ton mot de passe, tu dois te déconnecter puis te reconnecter',
        'login-auth/wrong-password':'Tu es sûr que tu es membre de Kids-Matin?',
        'login-auth/empty-user-and-password': 'Il faut que tu écrives ton pseudo et ton mot de passe',
        'login-auth/empty-user': 'Tu as oublié d\'écrire ton pseudo',
        'login-auth/empty-password': 'Tu as oublié d\'écrire ton mot de passe',
        'login-auth/user-not-found': 'Tu es sûr que tu es membre de Kids-Matin?',
    },
    'MESSAGE': {

    }
}


// WEBPACK FOOTER //
// ./src/conf/messagesDictionary.js